export default __webpack_public_path__ + "static/colored-noise@2x-f926e6483a3b10a08ef8a0710318d115.png";